export const delayInMilliseconds = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms))

export default {
  delayInMilliseconds,
}
